import { Link, useSearchParams } from "react-router-dom";
import documents from "../../../../clients/flutter/legal/documents.json";
import { Seo } from "../components/Seo";
import { useI18n } from "../i18n";

export function LegalPage({ kind }: { kind: "terms" | "privacy" }) {
  const [params] = useSearchParams();
  const { locale } = useI18n();
  const language = params.get("lang") === "en" ? "en" : params.get("lang") === "zh" ? "zh" : locale === "en-US" ? "en" : "zh";
  const content = documents[kind][language];
  const ready = Boolean(documents.operator && documents.contactEmail && documents.jurisdiction);
  return <article className="legal-document">
    <Seo />
    <nav aria-label={language === "zh" ? "协议导航" : "Legal documents"}>
      <Link to={`/terms?lang=${language}`} aria-current={kind === "terms" ? "page" : undefined}>{language === "zh" ? "用户协议" : "Terms"}</Link>
      <Link to={`/privacy?lang=${language}`} aria-current={kind === "privacy" ? "page" : undefined}>{language === "zh" ? "隐私政策" : "Privacy"}</Link>
      <Link to={`/${kind}?lang=${language === "zh" ? "en" : "zh"}`}>{language === "zh" ? "English" : "简体中文"}</Link>
    </nav>
    <h1>{content.title}</h1>
    <p className="legal-meta">{language === "zh" ? "版本 / 更新日期" : "Version / Updated"}: {documents.version}</p>
    {!ready && <p className="legal-draft" role="status">{language === "zh" ? "协议草稿：运营主体、隐私联系方式和适用地区尚待确认，本页暂未正式生效。" : "Draft: the operator, privacy contact and operating jurisdiction require confirmation. This document is not yet effective."}</p>}
    <dl className="legal-operator" id="contact">
      <dt>{language === "zh" ? "运营主体" : "Operator"}</dt><dd>{documents.operator ?? (language === "zh" ? "待确认" : "To be confirmed")}</dd>
      <dt>{language === "zh" ? "支持 / 隐私联系" : "Support / privacy contact"}</dt><dd>{documents.contactEmail ? <a href={`mailto:${documents.contactEmail}`}>{documents.contactEmail}</a> : (language === "zh" ? "待确认" : "To be confirmed")}</dd>
      <dt>{language === "zh" ? "运营地区" : "Operating jurisdiction"}</dt><dd>{documents.jurisdiction ?? (language === "zh" ? "待确认" : "To be confirmed")}</dd>
    </dl>
    <p>{content.intro}</p>
    {content.sections.map(section => <section key={section.title}><h2>{section.title}</h2>{section.paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}</section>)}
    <p className="legal-end"><Link to="/account">{language === "zh" ? "返回账户中心" : "Back to account"}</Link></p>
  </article>;
}
